// Fix dropped /en on PageFly links. Capture-phase = runs before PageFly's own
// handler, so we win over its frozen-closure window.open(n).
document.addEventListener('click', (e) => {
  const root = (window.Shopify?.routes?.root || '/').replace(/\/$/, ''); // "" (JP) or "/en"
  if (!root) return;                                   // inert on default locale
  const el = e.target.closest('a[href], [data-href]');
  if (!el) return;
  const url = el.getAttribute('href') || el.getAttribute('data-href') || '';
  if (!/^\/(collections|products|pages|blogs)\//.test(url)) return; // only content routes
  if (url.startsWith(root + '/')) return;              // already localized → leave PageFly alone
  const fixed = root + url;
  e.preventDefault();
  e.stopImmediatePropagation();                        // block PageFly's closure nav (no double-fire)
  const target = el.getAttribute('target') || el.getAttribute('data-target');
  if (e.ctrlKey || e.metaKey || target === '_blank') window.open(fixed, '_blank');
  else window.location.href = fixed;
}, true); // <-- capture
